import { Icon } from '@global-ecom/nitro-uds/elements';
import React from 'react';

import { AlertMessage } from 'ui/elements/AlertMessage';
import { useFeature } from 'hooks/useFeature';
import { GiftWithPurchasePromo } from '__generated__/graphql';
import { useTranslate } from 'hooks/useTranslations';

export const GWPFreeGiftMessage = ({
  gwpTitle,
}: {
  gwpTitle?: GiftWithPurchasePromo['gwpTitle'];
}) => {
  const t = useTranslate();
  const isGiftWithPurchaseNewDesign = useFeature(
    'GIFT_WITH_PURCHASE_NEW_DESIGN'
  );

  if (isGiftWithPurchaseNewDesign && gwpTitle)
    return (
      <div
        role="alert"
        className="flex items-center space-x-2 text-xs text-success-60"
      >
        <Icon name="gift" size="2xl" />
        <p className="font-bold uppercase text-sm mb-0.5">{gwpTitle}</p>
      </div>
    );

  if (!isGiftWithPurchaseNewDesign)
    return (
      <AlertMessage type="success" icon="gift" dataTestId="free-gift-message">
        {t('freeGiftWithPurchaseItem')}
      </AlertMessage>
    );

  return null;
};
